<template>
  <div class="chart-meter">
    <div class="chart-meter__grades">
      <div class="chart-meter__number"
           v-for="meterValue in meterValues"
           :key="meterValue.id">
        <span
          :style="valueClass">
          {{meterValue}}
        </span>
      </div>
    </div>
    <div :class="barClass"></div>
    <div class="chart-meter__legend">
      <span class="chart-meter__legend-text">
        {{legend}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    range: {
      type: Object,
      default: () => ({ x: [], y: [] })
    },
    zRange: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'divergent'
    },
    z: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      loadedValues: false,
      // Long values to reserve viewport space
      maxValue: 10000000000,
      minValue: 10000000000,
      legend: ''
    };
  },
  watch: {
    data: {
      handler (data) {
        this.onDataChanged(data);
      },
      deep: true
    },
    zRange: {
      handler () {
        this.onRangeChanged();
      },
      deep: true
    }
  },
  computed: {
    valueClass () {
      return this.loadedValues ? 'visibility: visible' : 'visibility: hidden';
    },
    barClass () {
      return this.type === 'divergent' ? 'chart-meter__bar_divergent' : 'chart-meter__bar_sequential';
    },
    meterValues () {
      const values = [];
      const formatWithDecimals = (this.maxValue - this.minValue) < 9;

      const step = (this.maxValue - this.minValue) / 8;
      for (let i = 0; i < 8; i++) {
        const value = this.minValue + step * i;
        const formattedValue = formatWithDecimals
          ? this.formatTwoDecimal(value)
          : this.formatTrunc(value);

        values.push(formattedValue);
      }

      const formattedValue = formatWithDecimals
        ? this.formatTwoDecimal(this.maxValue)
        : this.formatTrunc(this.maxValue);
      values.push(formattedValue);

      return values.reverse();
    }
  },
  methods: {
    onDataChanged (data) {
      if (data && data.variables) {
        for (let i = 0; i < data.variables.length; i++) {
          if (this.z === data.variables[i].metadata.id) {
            if (this.zRange.length > 0) {
              this.minValue = Number(this.zRange[0]);
              this.maxValue = Number(this.zRange[1]);
            } else {
              const array = data.variables[i].data;
              if (array.length > 0) {
                this.maxValue = array[0].value;
                this.minValue = array[0].value;
                for (let i = 1; i < array.length; i++) {
                  this.maxValue = Math.max(this.maxValue, array[i].value);
                  this.minValue = Math.min(this.minValue, array[i].value);
                }
              }
            }
            // Legend
            this.legend = data.variables[i].metadata.label;

            this.loadedValues = true;
            break;
          }
        }
      }
    },
    onRangeChanged () {
      this.minValue = Number(this.zRange[0]);
      this.maxValue = Number(this.zRange[1]);
    },
    formatTrunc (value) {
      return Math.trunc(value);
    },
    formatTwoDecimal (value) {
      return Number(value).toFixed(2);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";
.chart-meter {
  display: flex;
  height: auto;
  &__grades {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__number {
    font-size: $fs-xs;
    position: relative;
    padding-right: 1rem;
    text-align: right;
    word-wrap: break-word;
    max-width: 3.5rem;
    line-height: 1.1;
    &::after {
      content: "";
      display: inline-block;
      width: 0.8rem;
      margin-left: 0.2rem;
      border-bottom: 1px solid;
      position: absolute;
      top: 45%;
      right: 0;
    }
  }
  &__bar_divergent {
    width: 1rem;
    background: linear-gradient(#ffa138, rgba(#ffa138, 0.35), #38aadb);
  }
  &__bar_sequential {
    width: 1rem;
    background: linear-gradient($scatter-intensity-top, rgba($scatter-intensity-top, 0.35), $scatter-intensity-bottom);
  }
  &__legend {
    width: 1.3rem;
    position: relative;
  }
  &__legend-text {
    display: block;
    font-size: $fs-xs;
    white-space: nowrap;
    position: absolute;
    right: 0;
    top: 0;
    transform-origin: 100% 100%;
    transform: rotate(-90deg) translateX(1rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explorer/correlation/ChartMeter.vue